import { render, staticRenderFns } from "./Landata.vue?vue&type=template&id=ba779e88&scoped=true"
import script from "./Landata.vue?vue&type=script&lang=js"
export * from "./Landata.vue?vue&type=script&lang=js"
import style0 from "./Landata.vue?vue&type=style&index=0&id=ba779e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba779e88",
  null
  
)

export default component.exports